import React from 'react'
import styled from 'styled-components'
import { colors } from '../../Shared/colors'
import { ActiveFormDataTable } from '../../Components/SMM/ActiveForms/ActiveFormDataTable'

export const ActiveFromComponent = () => {
  return (
    <Main>
        <ActiveFormDataTable/>
    </Main>
  )
}

const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
padding-top: 2em;
display: flex;
justify-content: center;
align-items: center;
display: flex;
flex-direction: column;
`

